import { makeActionCreator } from "util/redux";

export const types = {
    LOAD_LIST_REQUEST: "contactDestination/LOAD_LIST_REQUEST",
    LOAD_LIST_FAILURE: "contactDestination/LOAD_LIST_FAILURE",
    LOAD_LIST_SUCCESS: "contactDestination/LOAD_LIST_SUCCESS",
    LOAD_DETAIL_REQUEST: "contactDestination/LOAD_DETAIL_REQUEST",
    LOAD_DETAIL_FAILURE: "contactDestination/LOAD_DETAIL_FAILURE",
    LOAD_DETAIL_SUCCESS: "contactDestination/LOAD_DETAIL_SUCCESS",
    FREQUENT_DESTINATION_CREATE_PREVIEW: "contactDestination/FREQUENT_DESTINATION_CREATE_PREVIEW",
    FREQUENT_DESTINATION_CREATE_PREVIEW_FAILED: "contactDestination/FREQUENT_DESTINATION_CREATE_PREVIEW_FAILED",
    FREQUENT_DESTINATION_CREATE_PREVIEW_SUCCESS: "contactDestination/FREQUENT_DESTINATION_CREATE_PREVIEW_SUCCESS",
    FREQUENT_DESTINATION_CREATE_FAILURE: `contactDestination/FREQUENT_DESTINATION_CREATE_FAILURE`,
    FREQUENT_DESTINATION_CREATE_REQUEST: `contactDestination/FREQUENT_DESTINATION_CREATE_REQUEST`,
    FREQUENT_DESTINATION_CREATE_SUCCESS: `contactDestination/FREQUENT_DESTINATION_CREATE_SUCCESS`,
    DELETE_FREQUENT_DESTINATION_PREVIEW_REQUEST: "contactDestination/DELETE_FREQUENT_DESTINATION_PREVIEW_REQUEST",
    DELETE_FREQUENT_DESTINATION_PREVIEW_FAILURE: "contactDestination/DELETE_FREQUENT_DESTINATION_PREVIEW_FAILURE",
    DELETE_FREQUENT_DESTINATION_PREVIEW_SUCCESS: "contactDestination/DELETE_FREQUENT_DESTINATION_PREVIEW_SUCCESS",
    DELETE_FREQUENT_DESTINATION_REQUEST: "contactDestination/DELETE_FREQUENT_DESTINATION_REQUEST",
    DELETE_FREQUENT_DESTINATION_FAILURE: "contactDestination/DELETE_FREQUENT_DESTINATION_FAILURE",
    DELETE_FREQUENT_DESTINATION_SUCCESS: "contactDestination/DELETE_FREQUENT_DESTINATION_SUCCESS",
    MODIFY_FREQUENT_DESTINATION_PRE_REQUEST: "contactDestination/MODIFY_FREQUENT_DESTINATION_PRE_REQUEST",
    MODIFY_FREQUENT_DESTINATION_PRE_FAILURE: "contactDestination/MODIFY_FREQUENT_DESTINATION_PRE_FAILURE",
    MODIFY_FREQUENT_DESTINATION_PRE_SUCCESS: "contactDestination/MODIFY_FREQUENT_DESTINATION_PRE_SUCCESS",
    MODIFY_FREQUENT_DESTINATION_PREVIEW_REQUEST: "contactDestination/MODIFY_FREQUENT_DESTINATION_PREVIEW_REQUEST",
    MODIFY_FREQUENT_DESTINATION_PREVIEW_FAILURE: "contactDestination/MODIFY_FREQUENT_DESTINATION_PREVIEW_FAILURE",
    MODIFY_FREQUENT_DESTINATION_PREVIEW_SUCCESS: "contactDestination/MODIFY_FREQUENT_DESTINATION_PREVIEW_SUCCESS",
    MODIFY_FREQUENT_DESTINATION_REQUEST: "contactDestination/MODIFY_FREQUENT_DESTINATION_REQUEST",
    MODIFY_FREQUENT_DESTINATION_FAILURE: "contactDestination/MODIFY_FREQUENT_DESTINATION_FAILURE",
    MODIFY_FREQUENT_DESTINATION_SUCCESS: "contactDestination/MODIFY_FREQUENT_DESTINATION_SUCCESS",
    FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_REQUEST:
        "contactDestination/FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_REQUEST",
    FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_FAILURE:
        "contactDestination/FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_FAILURE",
    FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_SUCCESS:
        "contactDestination/FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_SUCCESS",
    FREQUENT_DESTINATION_REQUEST: "contactDestination/FREQUENT_DESTINATION_REQUEST",
    FREQUENT_DESTINATION_FAILURE: "contactDestination/FREQUENT_DESTINATION_FAILURE",
    FREQUENT_DESTINATION_SUCCESS: "contactDestination/FREQUENT_DESTINATION_SUCCESS",
    GET_CBU_ACCOUNT_INFORMATION: "contactDestination/GET_CBU_ACCOUNT_INFORMATION",
    FREQUENT_DESTINATIONS_DOWLOAD: "contactDestination/FREQUENT_DESTINATIONS_DOWLOAD",
    FREQUENT_DESTINATIONS_DOWLOAD_SUCCESS: "contactDestination/FREQUENT_DESTINATIONS_DOWLOAD_SUCCESS",
    FREQUENT_DESTINATIONS_DOWLOAD_FAILURE: "contactDestination/FREQUENT_DESTINATIONS_DOWLOAD_FAILURE",
    CLEAN_CONTACT_TICKET: "contactDestination/CLEAN_CONTACT_TICKET",
    CONTACT_TICKET_SUCCESS: "contactDestination/CONTACT_TICKET_SUCCESS",
    CLEAN_FRECUENT_DESTINATION: "contactDestination/CLEAN_FRECUENT_DESTINATION",
    DOWNLOAD_DESTINATIONS: "contactDestination/DOWNLOAD_DESTINATIONS",
    CLEAN_FREQUENT_DESTINATION_LIST: "contactDestination/CLEAN_FREQUENT_DESTINATION_LIST",
    VALIDATE_CBU_BLOCKED: "contactDestination/VALIDATE_CBU_BLOCKED",
    VALIDATE_CBU_BLOCKED_RESPONSE: "contactDestination/VALIDATE_CBU_BLOCKED_RESPONSE",
};

export const INITIAL_STATE = {
    listFrequentDestinations: [],
    moreDestinations: false,
    fetching: false,
    frequentDestination: {},
    credentialGroups: [],
    isSubmitting: false,
    frequentDestinationDelete: {},
    frequentDestinationModify: {},
    reference: "",
    email: "",
    idDestinationModify: 0,
    alias: "",
    contactTicket: { status: "", idTransaction: "" },
    pageNumber: 1,
    cbuBlocked: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        frequentDestinations,
        moreStatements,
        data,
        credentialGroupsData,
        destinationDelete,
        destinationModify,
        contactTicket,
        pageNumber,
        totalPages,
        cbuBlocked,
    } = action;

    switch (action.type) {
        case types.LOAD_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.LOAD_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.LOAD_LIST_SUCCESS:
            return {
                ...state,
                listFrequentDestinations: frequentDestinations,
                moreDestinations: moreStatements,
                frequentDestinationModify: {},
                frequentDestinationDelete: {},
                fetching: false,
                pageNumber,
                totalPages,
            };
        case types.LOAD_DETAIL_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.LOAD_DETAIL_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.LOAD_DETAIL_SUCCESS:
            return {
                ...state,
                frequentDestination: frequentDestinations,
                fetching: false,
            };
        case types.FREQUENT_DESTINATION_CREATE_PREVIEW:
            return {
                ...state,
                fetching: true,
            };
        case types.FREQUENT_DESTINATION_CREATE_PREVIEW_FAILED:
            return {
                ...INITIAL_STATE,
                fetching: false,
            };
        case types.FREQUENT_DESTINATION_CREATE_PREVIEW_SUCCESS:
            return {
                ...state,
                fetching: false,
                frequentDestination: data.frequentDestination,
                alias: data.alias,
                credentialGroups: credentialGroupsData,
            };
        case types.FREQUENT_DESTINATION_CREATE_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.FREQUENT_DESTINATION_CREATE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.DELETE_FREQUENT_DESTINATION_PREVIEW_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DELETE_FREQUENT_DESTINATION_PREVIEW_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.DELETE_FREQUENT_DESTINATION_PREVIEW_SUCCESS:
            return {
                ...state,
                fetching: false,
                frequentDestinationDelete: destinationDelete,
            };
        case types.DELETE_FREQUENT_DESTINATION_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DELETE_FREQUENT_DESTINATION_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.DELETE_FREQUENT_DESTINATION_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.MODIFY_FREQUENT_DESTINATION_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.MODIFY_FREQUENT_DESTINATION_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.MODIFY_FREQUENT_DESTINATION_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                frequentDestinationModify: destinationModify,
            };
        case types.MODIFY_FREQUENT_DESTINATION_PREVIEW_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.MODIFY_FREQUENT_DESTINATION_PREVIEW_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.MODIFY_FREQUENT_DESTINATION_PREVIEW_SUCCESS:
            return {
                ...state,
                fetching: false,
                frequentDestinationModify: destinationModify,
            };
        case types.MODIFY_FREQUENT_DESTINATION_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.MODIFY_FREQUENT_DESTINATION_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.MODIFY_FREQUENT_DESTINATION_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                frequentDestination: data.frequentDestination,
                alias: data.alias,
            };
        case types.FREQUENT_DESTINATION_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.FREQUENT_DESTINATION_SUCCESS:
            return {
                ...state,
                fetching: false,
                frequentDestination: data.frequentDestinations[0],
                pageNumber: data.pageNumber,
            };
        case types.FREQUENT_DESTINATIONS_DOWLOAD:
            return {
                ...state,
                fetching: true,
            };
        case types.FREQUENT_DESTINATIONS_DOWLOAD_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.FREQUENT_DESTINATIONS_DOWLOAD_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.CONTACT_TICKET_SUCCESS:
            return {
                ...state,
                contactTicket,
            };
        case types.CLEAN_CONTACT_TICKET:
            return {
                ...state,
                contactTicket: { status: "", idTransaction: "" },
            };
        case types.CLEAN_FRECUENT_DESTINATION:
            return {
                ...state,
                frequentDestination: {},
            };
        case types.DOWNLOAD_DESTINATIONS:
            return {
                ...state,
                fetching: true,
            };
        case types.CLEAN_FREQUENT_DESTINATION_LIST:
            return {
                ...state,
                listFrequentDestinations: [],
            };
        case types.VALIDATE_CBU_BLOCKED:
            return {
                ...state,
                fetching: true,
                cbuBlocked: null,
            };
        case types.VALIDATE_CBU_BLOCKED_RESPONSE:
            return {
                ...state,
                fetching: false,
                cbuBlocked,
            };
        default:
            return state;
    }
};

export const actions = {
    loadListRequest: (filters, pageNo) => ({
        type: types.LOAD_LIST_REQUEST,
        filters,
        pageNo,
    }),
    loadListFailure: makeActionCreator(types.LOAD_LIST_FAILURE),
    loadListSuccess: makeActionCreator(types.LOAD_LIST_SUCCESS, "data"),
    loadDetailRequest: (id) => ({
        type: types.LOAD_DETAIL_REQUEST,
        id,
    }),
    downloadListFrequentDestinations: () => ({
        type: types.FREQUENT_DESTINATIONS_DOWLOAD,
    }),
    downloadListFrequentDestinationsSuccess: () => ({
        type: types.FREQUENT_DESTINATIONS_DOWLOAD_SUCCESS,
    }),
    downloadListFrequentDestinationsFailure: () => ({
        type: types.FREQUENT_DESTINATIONS_DOWLOAD_FAILURE,
    }),
    frequentDestinationCreatePreview: makeActionCreator(
        types.FREQUENT_DESTINATION_CREATE_PREVIEW,
        "params",
        "formikBag",
    ),
    frequentDestinationCreatePreviewFailed: makeActionCreator(types.FREQUENT_DESTINATION_CREATE_PREVIEW_FAILED),
    frequentDestinationCreatePreviewSuccess: makeActionCreator(
        types.FREQUENT_DESTINATION_CREATE_PREVIEW_SUCCESS,
        "data",
        "credentialGroupsData",
    ),
    frequentDestinationCreateRequest: makeActionCreator(
        types.FREQUENT_DESTINATION_CREATE_REQUEST,
        "frequentDestination",
        "formikBag",
        "credentialType",
    ),
    frequentDestinationCreateSuccess: makeActionCreator(types.FREQUENT_DESTINATION_CREATE_SUCCESS, "data"),
    frequentDestinationCreateFailure: makeActionCreator(types.FREQUENT_DESTINATION_CREATE_FAILURE),
    deleteFrequentDestinationPreviewRequest: (params) => ({
        type: types.DELETE_FREQUENT_DESTINATION_PREVIEW_REQUEST,
        params,
    }),
    deleteFrequentDestinationPreviewFailure: makeActionCreator(types.DELETE_FREQUENT_DESTINATION_PREVIEW_FAILURE),
    deleteFrequentDestinationPreviewSuccess: makeActionCreator(
        types.DELETE_FREQUENT_DESTINATION_PREVIEW_SUCCESS,
        "data",
    ),
    deleteFrequentDestinationRequest: makeActionCreator(
        types.DELETE_FREQUENT_DESTINATION_REQUEST,
        "frequentDestinationDelete",
        "formikBag",
        "credentialType",
    ),
    deleteFrequentDestinationFailure: makeActionCreator(types.DELETE_FREQUENT_DESTINATION_FAILURE),
    deleteFrequentDestinationSuccess: makeActionCreator(types.DELETE_FREQUENT_DESTINATION_SUCCESS, "data"),

    modifyFrequentDestinationPreRequest: makeActionCreator(
        types.MODIFY_FREQUENT_DESTINATION_PRE_REQUEST,
        "idFrequentDestination",
    ),
    modifyFrequentDestinationPreFailure: makeActionCreator(types.MODIFY_FREQUENT_DESTINATION_PRE_FAILURE),
    modifyFrequentDestinationPreSuccess: makeActionCreator(types.MODIFY_FREQUENT_DESTINATION_PRE_SUCCESS, "data"),
    modifyFrequentDestinationPreviewRequest: makeActionCreator(
        types.MODIFY_FREQUENT_DESTINATION_PREVIEW_REQUEST,
        "params",
    ),
    modifyFrequentDestinationPreviewFailure: makeActionCreator(types.MODIFY_FREQUENT_DESTINATION_PREVIEW_FAILURE),
    modifyFrequentDestinationPreviewSuccess: makeActionCreator(
        types.MODIFY_FREQUENT_DESTINATION_PREVIEW_SUCCESS,
        "data",
    ),
    modifyFrequentDestinationRequest: makeActionCreator(
        types.MODIFY_FREQUENT_DESTINATION_REQUEST,
        "frequentDestinationModify",
        "formikBag",
        "credentialType",
    ),
    modifyFrequentDestinationFailure: makeActionCreator(types.MODIFY_FREQUENT_DESTINATION_FAILURE),
    modifyFrequentDestinationSuccess: makeActionCreator(types.MODIFY_FREQUENT_DESTINATION_SUCCESS, "data"),
    createFrequentDestinationTransferPreRequest: makeActionCreator(
        types.FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_REQUEST,
        "cbuAlias",
    ),
    createFrequentDestinationTransferPreFailure: makeActionCreator(
        types.FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_FAILURE,
    ),
    createFrequentDestinationTransferPreSuccess: makeActionCreator(
        types.FREQUENT_DESTINATION_CREATE_TRANSFER_PRE_SUCCESS,
        "data",
    ),
    getFrequentDestinationRequest: makeActionCreator(types.FREQUENT_DESTINATION_REQUEST, "idEnvironment", "cbu"),
    getFrequentDestinationFailure: makeActionCreator(types.FREQUENT_DESTINATION_FAILURE),
    getFrequentDestinationSuccess: makeActionCreator(types.FREQUENT_DESTINATION_SUCCESS, "data"),
    getCbuAccountInformation: makeActionCreator(types.GET_CBU_ACCOUNT_INFORMATION, "params", "formikBag"),
    cleanContactTicket: () => ({
        type: types.CLEAN_CONTACT_TICKET,
    }),
    cleanFrecuentDestination: () => ({
        type: types.CLEAN_FRECUENT_DESTINATION,
    }),
    downloadDestinations: (search, format, pageNumber, totalPages) => ({
        type: types.DOWNLOAD_DESTINATIONS,
        search,
        format,
        pageNumber,
        totalPages,
    }),
    cleanFrecuentDestinationList: () => ({
        type: types.CLEAN_FREQUENT_DESTINATION_LIST,
    }),
    validateCbuBlocked: ({ creditCbu }) => ({
        type: types.VALIDATE_CBU_BLOCKED,
        creditCbu,
    }),
};

export const selectors = {
    getListFrequentDestinations: ({ contactDestination }) => contactDestination.listFrequentDestinations,
    getMoreDestinations: ({ contactDestination }) => contactDestination.moreDestinations,
    getEnviromentId: ({ session }) => session.activeEnvironment.id,
    getCredentialGroups: ({ contactDestination }) => contactDestination.credentialGroups,
    getFrequentDestination: ({ contactDestination }) => contactDestination.contactDestination,
    getIsSubmitting: ({ contactDestination }) => contactDestination.isSubmitting,
    getFrequentDestinationDelete: ({ contactDestination }) => contactDestination.frequentDestinationDelete,
    getFetching: ({ contactDestination }) => contactDestination.fetching,
    getFrequentDestinationModify: ({ contactDestination }) => contactDestination.frequentDestinationModify,
    getReference: ({ contactDestination }) => contactDestination.reference,
    getEmail: ({ contactDestination }) => contactDestination.email,
    getIdDestinationModify: ({ contactDestination }) => contactDestination.idDestinationModify,
    getAlias: ({ contactDestination }) => contactDestination.alias,
};
